<template>
    <div class="perfil-form">
        <form @submit.prevent="submit"
              ref="registro-form-form"
              novalidate
              :class="{
                'validated': validated
            }"
              v-if="!isSubmitting">
            <div class="row perfil-tab-row" v-if="pedirCambioPassword">
                <div class="col-sm-6 col-md-4"></div>
                <div class="col-sm-6 col-md-4">
                    <div class="form-group">
                        <label for="registro-form-password">Password</label>
                        <input type="password"
                               :class="{
                                'form-control': true,
                                'is-invalid': validated && (password == '' || password != repeatPassword),
                                'is-valid': validated && password != '' && password == repeatPassword
                            }"
                               name="password"
                               id="registro-form-password"
                               placeholder="Nuevo password"
                               autocomplete="off"
                               v-model="password">
                        <div class="invalid-feedback">Password inválido</div>
                    </div>
                    <div class="form-group">
                        <label for="registro-form-repeat">Repetir password</label>
                        <input type="password"
                               :class="{
                                'form-control': true,
                                'is-invalid': validated && (repeatPassword == '' || password != repeatPassword),
                                'is-valid': validated && repeatPassword != '' && password == repeatPassword
                            }"
                               name="repeat-password"
                               id="registro-form-repeat"
                               placeholder="Repetir nuevo password"
                               v-model="repeatPassword">
                        <div class="invalid-feedback">El password no coincide</div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-2"></div>

            </div>

            <p class="text-center">
                <button v-if="error==null" class="btn btn-primary">
                    Activar ahora
                </button>
            </p>
            <div class="perfil-alert"
                 v-if="alert.visible">
                <font-awesome-icon
                    :icon="alert.icon"
                    :class="{
                        'color-orange': true,
                        spin: alert.iconSpin
                    }"/>
                {{ alert.message }}
            </div>
        </form>
    </div>
</template>

<script>
import Vue from "vue";
import {mapGetters} from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {randomString, isValidEmail} from "../utilities/util";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faCheck,
    faSpinner,
    faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

library.add(faCheck, faSpinner, faExclamationTriangle);

export default {
    components: {
        VueGoogleAutocomplete,
        FontAwesomeIcon
    },
    props: ["TOKEN_CLAVE_RECUPERAR"],
    data() {
        return {
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false
            },
            id: 0,
            label: null,
            isSubmitting: false,
            password: "",
            repeatPassword: "",
            validated: false,
            pedirCambioPassword: false,
            error: null,
            status_code: null
        };
    },
    computed: {
        ...mapGetters(["user", "portal"])
    },
    created() {
        if ((typeof this.$route.query.cambio_pass != "undefined" && this.$route.query.cambio_pass == 1)) {
            this.pedirCambioPassword = true;
        }
    }
    ,
    methods: {

        toggleLoginModal(toggle) {
            this.$store.commit("togglePortalLoginModal", toggle);
        },
        submit() {
            this.error = null
            this.validated = true;
            let isValid = true;
            if ((this.password != this.repeatPassword || this.password == "") && (typeof this.$route.query.cambio_pass != "undefined" && this.$route.query.cambio_pass == 1))
                isValid = false;

            let newUserData = {
                TOKEN_CLAVE_RECUPERAR: this.$route.params.token,
                password: this.password
            };

            if (isValid) {
                this.showAlert({
                    iconSpin: true,
                    message: "Activando...",
                    icon: "spinner"
                });
                this.$api.activar_usuario(newUserData)
                    .then(response => {
                        this.$log.info(response)
                        if (response.data.success) {
                            this.$router.push({
                                name: "home"
                            });
                            this.toggleLoginModal(true);
                        } else {
                            this.error = response.data.message
                            this.showAlert({
                                iconSpin: true,
                                message: this.error,
                                icon: "spinner"
                            });
                            let self = this
                            setTimeout(() => {
                                self.$router.push({
                                    name: "home"
                                });
                                self.toggleLoginModal(true);
                            }, 4000);
                        }
                    })
                    .catch(error => {
                        this.error = error.response.data.message
                        this.showAlert({
                            iconSpin: false,
                            message: this.error,
                            icon: ""
                        });
                        let self = this
                        setTimeout(() => {
                            self.$router.push({
                                name: "home"
                            });
                        }, 4000);
                    });
            }
        },
        showAlert(options, autoHide) {
            this.alert.visible = true;
            this.alert = Object.assign(this.alert, options);
            if (autoHide)
                setTimeout(() => {
                    this.alert.visible = false;
                }, 3000);
        }
    }
};
</script>
